import { LoaderFunctionArgs, redirect } from 'react-router-dom';

export const redirectWithSearch = (pathname: string) => {
  return ({ request }: LoaderFunctionArgs) => {
    const url = new URL(request.url);
    return redirect(`${pathname}${url.search}`);
  };
};
